var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    [
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.name,
            expression: "rules.name"
          }
        ],
        attrs: {
          label: "Name",
          name: "Name",
          placeholder: "Valid zone name",
          "error-messages": _vm.errors.collect("Name")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.name,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "name", $$v)
          },
          expression: "model.name"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.ttl,
            expression: "rules.ttl"
          }
        ],
        attrs: {
          label: "TTL",
          name: "TTL",
          placeholder: "14400",
          "error-messages": _vm.errors.collect("TTL")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.ttl,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "ttl", $$v)
          },
          expression: "model.ttl"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.address,
            expression: "rules.address"
          }
        ],
        attrs: {
          label: "IPv6 address",
          name: "IPv6 address",
          "error-messages": _vm.errors.collect("IP address")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.address,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "address", $$v)
          },
          expression: "model.address"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }